// Utility to check if a file is a Lottie JSON (by extension or content)
export function isLottieFile(urlOrObject: string | any): boolean {
  if (typeof urlOrObject === "string") {
    // Check for .json extension and possible lottie naming
    return urlOrObject.trim().toLowerCase().endsWith(".json")
  }
  // If object, check for lottie animation structure
  if (typeof urlOrObject === "object" && urlOrObject !== null) {
    return (
      typeof urlOrObject.v === "string" &&
      Array.isArray(urlOrObject.layers) &&
      typeof urlOrObject.assets !== "undefined"
    )
  }
  return false
}
